import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ClientVersionDto, ApiVersionDto } from "./versionInterfaces";
import { receiveAxiosError, receiveError } from "../../errors/data/errorSlice";
import {SIGNALR_CONNECTED, SIGNALR_DISCONNECTED} from "../../../actions/SignalRActionTypes";
import semverGt from "semver/functions/gt";
import { SESSION_TERMINATED, USER_EXPIRED, USER_FOUND } from "redux-oidc";
import {UserFoundAction} from "../../../actions/OidcActionTypes";

export interface InitialState {
    isLoading: boolean;
    isLoaded: boolean;
    expiresAt?: number;
    clientVersion: ClientVersionDto;
    apiVersion?: ApiVersionDto;
    isConnected: boolean;
    requiresUpdate: boolean;
}

export const initialState: InitialState = {
    isLoading: false,
    isLoaded: false,
    expiresAt: undefined,
    clientVersion: {
      version: process.env.REACT_APP_VERSION ?? "0.0.0",
    },
    apiVersion: undefined,
    isConnected: false,
    requiresUpdate: false,
};

export const requestCurrentVersion = createAsyncThunk(
  "version/requestVersion",
  async (_params, thunkApi) => {
    const { dispatch } = thunkApi;
        try {
            const response = await axios.request<ApiVersionDto>({
                url: "./api/version",
              });
            return response.data;
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                dispatch(receiveAxiosError({ error, message: error.response?.data }));
            } else {
                dispatch(receiveError({ error }));
            }
            return thunkApi.rejectWithValue(error);
        }
  }
);

export const versionSlice = createSlice({
  name: "version",
  initialState,
  reducers: { },
  extraReducers: builder => {
    builder
      .addCase(requestCurrentVersion.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(requestCurrentVersion.fulfilled, (state, action) => {
        var requiresUpdate = false;
        if (
            state.apiVersion !== undefined &&
            semverGt(action.payload.informationalVersion, state.clientVersion.version)
        ) {
            requiresUpdate = true;
        }
        state.apiVersion = action.payload;
        state.isLoading = false;
        state.isLoaded = true;
        state.requiresUpdate = requiresUpdate
      })
      .addCase(requestCurrentVersion.rejected, (state) => {
        state.apiVersion = undefined;
        state.requiresUpdate = true;
      })
      .addCase(SIGNALR_CONNECTED, (state) => {
        state.isConnected = true;
        state.isLoaded = false;
      })
      .addCase(SIGNALR_DISCONNECTED, (state) => {
        state.isConnected = false;
      })
      .addCase(SESSION_TERMINATED, (state) => {
        state.expiresAt = undefined;
      })
      .addCase(USER_EXPIRED, (state) => {
        state.expiresAt = undefined;
      })
      .addCase(USER_FOUND, (state, action: UserFoundAction) => {
        state.expiresAt = action.payload.expires_at;
      });
  },
});

export const { } = versionSlice.actions;
export default versionSlice;
